import type { FC } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Sidebar } from './Sidebar';

export const AppLayout: FC = () => {
  const location = useLocation();
  const isWebmail = location.pathname.startsWith('/webmail');

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex flex-col">
      <Navbar />
      <div className="flex-1 flex overflow-hidden">
        <Sidebar />
        <main
          className={
            isWebmail
              ? 'flex-1 overflow-hidden p-0 flex flex-col bg-slate-950'
              : 'flex-1 overflow-y-auto p-6 md:p-10'
          }
        >
          <div className={isWebmail ? 'h-full w-full' : 'max-w-6xl mx-auto'}>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};
